import React from "react"
import styled from "@emotion/styled"
import { Link } from "gatsby"
import { Container, Flex, Box } from "theme-ui"

const Wrapper = styled.div`
    position: relative;
    // background: url(${process.env
        .GATSBY_ROOT_URL}/homepage/bg-whyus.png) no-repeat;
    background-size: 100% 100%;
    text-align: center;
    margin-bottom: 3rem;
    padding-bottom: 3rem;

    & .whyus-wrapper {
        justify-content: space-between;
        margin: auto;
        flex-direction: row;
        z-index: 3;
    }
    & h2 {
        margin-bottom: 0;
        z-index: 3;
    }
    & p,
    .title {
        z-index: 3;
        color: ${(props) => props.theme.colors.text1};
    }

    @media (max-width: ${(props) => props.theme.breakpoints[8]}) {
        padding: 2rem 2rem;
    }
    @media (max-width: ${(props) => props.theme.breakpoints[6]}) {
        & h2 {
            margin-top: 0;
        }
    }
    @media (max-width: ${(props) => props.theme.breakpoints[4]}) {
        & .whyus-wrapper {
            justify-content: center;
            flex-direction: column;
            padding: 1rem;
        }
    }
    @media (max-width: ${(props) => props.theme.breakpoints[3]}) {
        & .whyus-wrapper {
            padding: 0;
        }
    }
`

const WhyUsBox = styled(Box)`
    width: 450px;
    height: auto;
    background: #ffffff;
    margin: 2rem;
    box-shadow: rgba(0, 0, 0, 0.24) 4px 5px 8px;
    border-radius: 0 0 1rem 1rem;
    z-index: 3;
    padding-bottom: 3rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    & .title-box {
        width: 100%;
        display: flex;
        margin-top: 1rem;
        border-bottom: 0.5rem solid #faab2a;
        justify-content: center;

        & h3 {
            color: #faab2a;
            font-family: Museo Slab;
        }

        & img {
            width: 100px;
        }

        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[7]}) {
            & h3 {
                font-size: 25px;
            }
        }

        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[5]}) {
            & h3 {
                margin-left: 0;
            }
        }

        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[4]}) {
            & img {
                width: 75px;
            }
            & h3 {
                font-size: 20px;
            }
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[3]}) {
            & h3 {
                font-size: 25px;
            }
        }
    }

    & p {
        margin: 2rem;
        text-align: center;
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[4]}) {
            margin: 1.5rem;
        }
    }
    & a {
        background: ${(props) => props.theme.colors.light_blue_1};
        border-radius: 2rem;
        padding: 1rem 1.7rem;
        color: #ffffff;
        text-decoration: none;
        margin-top: auto;

        &:hover {
            text-decoration: none;
        }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[8]}) {
        & p {
            font-size: 22px;
        }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[7]}) {
        & p {
            font-size: 20px;
        }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[5]}) {
        margin: 1rem;

        & a {
            font-size: 14px;
            padding: 0.7rem 1.5rem;
        }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        height: auto;
        padding-bottom: 2rem;
        margin: 1rem auto;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[2]}) {
        width: 100%;
    }
`

const BgContainer = styled(Container)`
    background: url(${process.env
            .GATSBY_ROOT_URL}/homepage/bg-whyus-overlay.png)
        no-repeat;
    background-size: 100% 85%;
    // z-index: -1;
    & .demo-bg {
        opacity: 0.8;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[6]}) {
        background-size: 100% auto;
    }
`

function WhyUs({ data, description }) {
    let ourProgram = null
    let whyEIP = null
    let letsGetStarted = null
    data.map((desc) => {
        const title = desc.title.toLowerCase()
        if (title.includes("program")) {
            ourProgram = desc.content
        } else if (title.includes("why")) {
            whyEIP = desc.content
        } else if (title.includes("lets")) {
            letsGetStarted = desc.content
        }
        return true
    })
    return (
        <Wrapper>
            <BgContainer>
                <img className="demo-bg" src="/homepage/bg-whyus.png" alt="" />
                <Flex sx={{ justifyContent: "center" }}>
                    <h2>Why Us</h2>
                </Flex>
                <Flex
                    sx={{
                        justifyContent: "center",
                        margin: "auto",
                    }}
                    className="content-padding"
                >
                    <div
                        className="title"
                        dangerouslySetInnerHTML={{ __html: description }}
                    />
                </Flex>
                <Flex className="whyus-wrapper">
                    <WhyUsBox>
                        <div className="title-box">
                            <Box>
                                <img
                                    src={`/homepage/icons/icon_bulb.svg`}
                                    alt=""
                                />
                            </Box>
                            <Box>
                                <h3 style={{ color: "#faab2a" }}>
                                    Our Programs
                                </h3>
                            </Box>
                        </div>
                        <div dangerouslySetInnerHTML={{ __html: ourProgram }} />
                        <Link to="/our-programs/after-school-care-program">
                            Read More
                        </Link>
                    </WhyUsBox>
                    <WhyUsBox>
                        <div
                            className="title-box"
                            style={{ borderColor: "#6ABE0B" }}
                        >
                            <Box>
                                <img
                                    src={`/homepage/icons/icon_awards.svg`}
                                    alt=""
                                />
                            </Box>
                            <Box>
                                <h3 style={{ color: "#6ABE0B" }}>Why EIP?</h3>
                            </Box>
                        </div>
                        <div dangerouslySetInnerHTML={{ __html: whyEIP }} />
                        <Link to="/about-us/why-choose-us">Read More</Link>
                    </WhyUsBox>
                    <WhyUsBox>
                        <div
                            className="title-box"
                            style={{ borderColor: "#FA632A" }}
                        >
                            <Box>
                                <img
                                    src={`/homepage/icons/icon_rocket.svg`}
                                    alt=""
                                />
                            </Box>
                            <Box>
                                <h3 style={{ color: "#FA632A" }}>
                                    Lets Get Started
                                </h3>
                            </Box>
                        </div>
                        <div
                            dangerouslySetInnerHTML={{ __html: letsGetStarted }}
                        />
                        <Link to="/about-us/getting-started">Read More</Link>
                    </WhyUsBox>
                </Flex>
            </BgContainer>
        </Wrapper>
    )
}

export default WhyUs
